import { FC } from 'react'
import { useSelector } from 'react-redux'
import { RootStoreState } from 'mytours-read-common'
import CardImage from 'mobile_web/modules/common/components/card-image'
import { generateImageUrl } from 'common_lib/utils'
import { ImageSizePreset, ImageSizePresetMap } from 'common_lib/types'
import { onLinkAction } from 'mobile_web/modules/screen/functions'
import strings from '../../../strings'
import { PurchasedItem } from '../usePurchasedContent'

interface Props {
	item: PurchasedItem
	imageSizePreset: ImageSizePreset
}

// A single purchased/redeemed item rendered as a read-only CardImage. Shared by the Profile/Settings
// shelf (PurchasedContentBlock) and the full grid (PurchasedContentScreen); they differ only in the
// image size preset and their own grid container.
const PurchasedContentCard: FC<Props> = ({ item, imageSizePreset }) => {
	const appMetaData = useSelector((state: RootStoreState) => state.settings.appMetaData)
	const size = { imageSizePreset, ...ImageSizePresetMap[imageSizePreset] }

	const onClick = (): void =>
		onLinkAction(
			item.subtype,
			item.itemId,
			item.version,
			() => undefined,
			undefined,
			undefined,
			undefined,
			item.accountId,
		)

	const file = item.coverImage?.file
	const focalPoint = file?.focal_point
	const crop = focalPoint && (focalPoint[0] !== 0.5 || focalPoint[1] !== 0.5)
	const image = file && generateImageUrl(file, { ...size, crop, focalPoint })
	const image2x = file && generateImageUrl(file, { width: size.width * 2, height: size.height * 2, crop, focalPoint })

	return (
		<CardImage
			loading={false}
			className="collection-list-item list-card-image"
			image={image}
			image2x={image2x}
			label={item.title}
			role="button"
			// An untitled item (optional in the IAP catalogue) must still give the button a name.
			aria-label={item.title || strings.purchased_content}
			onClick={onClick}
			itemId={item.itemId}
			itemType={item.itemType}
			item={item}
			appMetaData={appMetaData}
			showFavourite={false}
		/>
	)
}

export default PurchasedContentCard
